import { axiosRequest, axiosRequestData } from "../helpers/axios";
import { API_ENDPOINTS } from "../helpers/constants";

type RecaptchaMethod = "score" | "checkbox";

export type AuthApiResponse = {
  success: boolean;
  message: string;
  [key: string]: any;
};

const unwrap = async (request: Promise<any>): Promise<AuthApiResponse> => {
  const response = await request;
  return response.data as AuthApiResponse;
};

export const createAccount = async (payload: {
  username: string;
  password: string;
  campaign?: string | null;
}): Promise<AuthApiResponse> => {
  return unwrap(axiosRequestData("POST", API_ENDPOINTS.CREATE_ACCOUNT, payload));
};

export const createAccountFromEmail = async (payload: {
  email: string;
  key: string;
  password: string;
}): Promise<AuthApiResponse> => {
  return unwrap(axiosRequestData("POST", API_ENDPOINTS.CREATE_ACCOUNT_FROM_EMAIL, payload));
};

export const forgotPassword = async (payload: {
  username: string;
}): Promise<AuthApiResponse> => {
  return unwrap(axiosRequestData("POST", API_ENDPOINTS.FORGOT_PASSWORD, payload));
};

export const forgotUpdatePassword = async (payload: {
  email: string;
  key: string;
  password: string;
  password2: string;
}): Promise<AuthApiResponse> => {
  return unwrap(axiosRequestData("POST", API_ENDPOINTS.FORGOT_UPDATE_PASSWORD, payload));
};

export const loginUser = async (payload: {
  username: string;
  password: string;
  remember: boolean;
}): Promise<AuthApiResponse> => {
  return unwrap(axiosRequestData("POST", API_ENDPOINTS.LOGIN, payload));
};

export const validateRecaptcha = async (payload: {
  token: string;
  method: RecaptchaMethod;
}): Promise<AuthApiResponse> => {
  return unwrap(axiosRequestData("POST", API_ENDPOINTS.VALIDATE_RECAPTCHA, payload));
};

export const authApi = {
  login: (username: string, password: string, remember: boolean) =>
    axiosRequestData("POST", API_ENDPOINTS.LOGIN, { username, password, remember }),

  logout: () => axiosRequestData("POST", API_ENDPOINTS.LOGOUT, {}),

  checkAuthStatus: () => axiosRequest("GET", API_ENDPOINTS.AUTH_STATUS),

  createAccountPostPurchase: (username: string, password: string) =>
    axiosRequestData("POST", API_ENDPOINTS.CREATE_ACCOUNT_POST_PURCHASE, { username, password }),

  createAccount: (username: string, password: string, campaign?: string) =>
    axiosRequestData("POST", API_ENDPOINTS.CREATE_ACCOUNT, { username, password, campaign }),

  forgotPassword: (username: string) =>
    axiosRequestData("POST", API_ENDPOINTS.FORGOT_PASSWORD, { username }),

  forgotUpdatePassword: (email: string, key: string, password: string, password2: string) =>
    axiosRequestData("POST", API_ENDPOINTS.FORGOT_UPDATE_PASSWORD, { email, key, password, password2 }),

  validateRecaptcha: (token: string, method: string) =>
    axiosRequestData("POST", API_ENDPOINTS.VALIDATE_RECAPTCHA, { token, method }),
};
